import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { Error } from './error/error';

@Component({
    selector: 'stby-errors',
    templateUrl: './errors.html',
    imports: [Error, TranslatePipe],
})
export class Errors {
    readonly errors = input<string[]>([]);
}
